// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G3uiM","index":"styles_index__2P9os"};